<template>
  <div class="root">
    <article>
      <div class="left">
        <ul>
          <li :class="{'select': type == item.type }" v-for="(item, index) in list" :key="index">
            <a href="javascript:void(0);" @click="changeType(item.type)">{{item.name}}</a>
          </li>
        </ul>
      </div>
      <div class="right">
        <brand-info v-if="type == 0" />
        <franchise-info v-if="type == 1" />
        <application-info v-if="type == 2" />
      </div>
    </article>
  </div>
</template>

<script>
// 默认声明配置
import BrandInfo from './brand.vue';
import FranchiseInfo from './franchise.vue';
import ApplicationInfo from './application.vue';

export default {
  name: 'info-root',
  beforeRouteUpdate(to, from, next) {
    // 设置对应的声明显示
    this.setContent(to.params.type);
    next();
  },
  data() {
    return {
      type: 0,
      list: [
        {
          name: this.$t('statement.brandIntroduction'),
          type: 0,
        },
        // {
        //   name: this.$t('statement.franchiseSystem'),
        //   type: 1,
        // },
        // {
        //   name: this.$t('statement.application'),
        //   type: 2,
        // },
      ],
    };
  },
  methods: {
    // 从配置文件获取对应的声明显示
    setContent(key) {
      this.type = key;
    },
    changeType(type) {
      this.$router.push(`/info-root/${type}`);
    },
  },
  created() {
    this.setContent(this.$route.params.type);
  },
  components: {
    BrandInfo,
    FranchiseInfo,
    ApplicationInfo,
  },
};

</script>

<style lang="sass" scoped>
@import '../../../assets/css/mixins'

.root
  @include base-wrap
  overflow: hidden
  article
    min-height: 650px
    // background-color: #f5f5f5
    // margin-top: 20px
    margin-bottom: 14px
</style>
<style lang="scss" scoped>
.left, .right {
  float: left;
}
.left {
  width: 200px;
  ul {
    li {
      a {
        margin: 8px 0;
        width: 200px;
        // height: 36px;
        line-height: 36px;
        display: block;
        padding-left: 15px;
        color: #000;
        font-size: 15px;
        &:first-child {
          margin-top: 0;
        }
      }
      &.select {
        background: url('../../../assets/image/info/ico1.jpg') no-repeat;
      }
    }
  }
}
.right {
  border-radius: 5px;
  border: solid 1px #ccc;
  margin: 0 0 20px 15px;
  width: calc(100% - 220px);
  padding: 20px;
}
</style>
